import { render, staticRenderFns } from "./InviteCoparentModal.vue?vue&type=template&id=421b70ee"
import script from "./InviteCoparentModal.vue?vue&type=script&lang=js"
export * from "./InviteCoparentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports